import * as Yup from "yup";
import { Formik } from 'formik';

import {
    Grid,
    Dialog,
    TextField,
    Container,
    Autocomplete,
    CardContent,
    IconButton,
    DialogTitle,
    Divider,
    Card
} from "@mui/material";
import { ActionButton } from "../../../utils/ui_utils";
import { Close } from '@mui/icons-material'

function ApplicatonDialog({
    visible,
    title,
    initialValues,
    okText,
    onSubmit,
    onClose,
    modulesData
}) {

    BigInt.prototype.toJSON = function () {
        return this.toString()
    }

    if (initialValues == undefined)
        initialValues = {
            application_name: '',
            modules: []
        }
    if (modulesData == undefined)
        modulesData = []


    const validationSchema = Yup.object().shape({
        application_name: Yup.string().required("Required"),
        modules: Yup.array().of(
            Yup.object().shape({
                _id: Yup.string()
            })
        )
    });

    const handleSubmit = async (
        values,
        { resetForm, setErrors, setStatus, setSubmitting }
    ) => {
        onSubmit(values);
    };

    return (
        <>
            <Dialog maxWidth='xs' fullWidth open={visible} aria-labelledby="form-dialog-title">
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            touched,
                            values,
                            status,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card>
                                    <CardContent>
                                        <Grid container direction="column" spacing={5} style={{ paddingTop: 1 }}>
                                            <Grid item>
                                                <TextField
                                                    size="small"
                                                    name="application_name"
                                                    label="Application Name"
                                                    value={values.application_name}
                                                    error={Boolean(touched.application_name && errors.application_name)}
                                                    fullWidth
                                                    helperText={touched.application_name && errors.application_name}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <Autocomplete
                                                    size="small"
                                                    multiple
                                                    id="modules_select"
                                                    name="modules"
                                                    options={modulesData}
                                                    getOptionLabel={(option) => option.module_name}
                                                    isOptionEqualToValue={(option, value) => option._id === value._id}
                                                    value={values.modules}
                                                    onChange={(e, value) => {
                                                        setFieldValue("modules", value);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            label="modules"
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item  >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Dialog>
        </>
    );
}

export default ApplicatonDialog;